import React,{useEffect,useState} from "react";
import { Link } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';



function CountryC(){
    const[ctr,upctr]=useState([]);
    

    const GetCtr=async()=>{
        
        upctr([{
            "strArea": "merican",
                "strCode":'me'
            },
            {
                "strArea": "British",
                "strCode":'br'
            },
            {
                "strArea": "Canadian",
                "strCode":'ca'
            },
            {
                "strArea": "Chinese",
                "strCode":'cn'
            },
            {
                "strArea": "Croatian",
                "strCode":'cr'
            },
            {
                "strArea": "Dutch",
                "strCode":'nl'
            },
            {
                "strArea": "Egyptian",
                "strCode":'eg'
            },
            {
                "strArea": "French",
                "strCode":'fr'
            },
            {
                "strArea": "Greek",
                "strCode":'gr'
            },
            {
                "strArea": "Indian",
                "strCode":'in'
            },
            {
                "strArea": "Irish",
                "strCode":'ir'
            },
            {
                "strArea": "Italian",
                "strCode":'it'
            },
            {
                "strArea": "Jamaican",
                "strCode":'jm'
            },
            {
                "strArea": "Japanese",
                "strCode":'jp'
            },
            {
                "strArea": "Kenyan",
                "strCode":'ke'
            },
            {
                "strArea": "Malaysian",
                "strCode":'ma'
            },
            {
                "strArea": "Mexican",
                "strCode":'me'
            },
            {
                "strArea": "Moroccan",
                "strCode":'ma'
            },
            {
                "strArea": "Polish",
                "strCode":'pl'
            },
            {
                "strArea": "Portuguese",
                "strCode":'pr'
            },
            {
                "strArea": "Russian",
                "strCode":'ru'
            },
            {
                "strArea": "Spanish",
                "strCode":'es'
            },
            {
                "strArea": "Thai",
                "strCode":'th'
            },
            {
                "strArea": "Tunisian",
                "strCode":'tn'
            },
            {
                "strArea": "Turkish",
                "strCode":'tr'
            },
            {
                "strArea": "Vietnamese",
                "strCode":'vi'
            }])
        
    }
    useEffect(()=>{
        GetCtr();
    },[])
    return(
        <>
          <div className="maindivcountry">
              <h1>Browse Country</h1>
          <div className="countrydiv">
          { ctr.map((curelem,index)=>{
              return( <>
                  <div key={index}>
            <Link to='/country' state={curelem.strArea}>
            <Tooltip title={curelem.strArea} arrow>
            <img src={`https://www.themealdb.com/images/icons/flags/big/64/${curelem.strCode}.png`} alt="Flag" />
           </Tooltip>
           </Link>
          </div>
              </>
              )
          })
          
          }
          
        </div>
          </div>
        </>
    )
}

export default CountryC;